'use client';

import * as React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { Plate, PlateController, HtmlDeserializer } from '@udecode/plate/react';

import { useCreateEditor } from '@/components/editor/use-create-editor';
import { SettingsDialog } from '@/components/editor/settings';
import { Editor, EditorContainer } from '@/components/ui/editor';

import { serializeHtml } from '@udecode/plate';
import { staticComponents } from './staticComponents';
import { deserializeHtml } from '@udecode/plate'








import { CalloutPlugin } from '@udecode/plate-callout/react';
import { CodeBlockPlugin } from '@udecode/plate-code-block/react';
import { DatePlugin } from '@udecode/plate-date/react';
import { DocxPlugin } from '@udecode/plate-docx';
import { EmojiPlugin } from '@udecode/plate-emoji/react';
import {
  FontBackgroundColorPlugin,
  FontColorPlugin,
  FontSizePlugin,
} from '@udecode/plate-font/react';
import { HighlightPlugin } from '@udecode/plate-highlight/react';
import { HorizontalRulePlugin } from '@udecode/plate-horizontal-rule/react';
import { JuicePlugin } from '@udecode/plate-juice';
import { KbdPlugin } from '@udecode/plate-kbd/react';
import { ColumnPlugin } from '@udecode/plate-layout/react';
import { SlashPlugin } from '@udecode/plate-slash-command/react';
import { TogglePlugin } from '@udecode/plate-toggle/react';
import { TrailingBlockPlugin } from '@udecode/plate-trailing-block';
import { FixedToolbarPlugin } from '@/components/editor/plugins/fixed-toolbar-plugin';
import { FloatingToolbarPlugin } from '@/components/editor/plugins/floating-toolbar-plugin';
import { SuggestionBelowNodes } from '@/components/ui/suggestion-line-break';

export const viewPlugins = [
  HorizontalRulePlugin,
  DatePlugin,
  TogglePlugin,
  CalloutPlugin,
  ColumnPlugin,
  // Marks
  FontColorPlugin,
  FontBackgroundColorPlugin,
  FontSizePlugin,
  HighlightPlugin,
  KbdPlugin,
  // Block Style
  // Collaboration
] as const;
export const editorPlugins = [
  // AI
  // Nodes
  ...viewPlugins,
  // Functionality
  SlashPlugin.extend({
    options: {
      triggerQuery(editor) {
        return !editor.api.some({
          match: { type: editor.getType(CodeBlockPlugin) },
        });
      },
    },
  }),
  TrailingBlockPlugin,
  // Deserialization
  DocxPlugin,
  JuicePlugin,
  // UI
  FixedToolbarPlugin,
  FloatingToolbarPlugin,
];







export function PlateEditor(props) {
  const editor = useCreateEditor();
  const tmpEditor = useCreateEditor({ editorPlugins });
  const [htmlContent, setHtmlContent] = React.useState('');

  React.useEffect(() => {
    if (editor && editor.selection) {
      editor.insertText(props.selectedWord);
    }
  }, [props.selectedWord]);
  
  React.useEffect(() => {
    if (editor && props.editTemp) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(props.templateHtml, 'text/html');

      // Extract the inner HTML of the <body> tag
      const bodyInnerHTML = doc.body.innerHTML;
      
      let valueForEditor = deserializeHtml(tmpEditor, { element: bodyInnerHTML });
      editor.tf.setValue(valueForEditor);



      // const slateValue = editor.api.html.deserialize(bodyInnerHTML, true, true);
      // // let valueForEditor = HtmlDeserializer()
      // editor.tf.setValue(slateValue);
    }
  }, [props.editTemp]);

  React.useEffect(() => {
    if (editor && !props.htmlMode) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(props.templateHtml, 'text/html');

      // Extract the inner HTML of the <body> tag
      const bodyInnerHTML = doc.body.innerHTML;
      
      let valueForEditor = deserializeHtml(tmpEditor, { element: bodyInnerHTML });
      editor.tf.setValue(valueForEditor);



      // const slateValue = editor.api.html.deserialize(bodyInnerHTML, true, true);
      // // let valueForEditor = HtmlDeserializer()
      // editor.tf.setValue(slateValue);
    }
  }, [props.htmlMode]);


  return (
    <DndProvider backend={HTML5Backend}>
      <Plate editor={editor}>
        <EditorContainer className="editor-outerwrapper-style">
          <Editor variant="demo" />
        </EditorContainer>
        <SettingsDialog />
      </Plate>
    </DndProvider>
  );
}
